(function ($, Drupal) {

  const swapTab = function (hash) {

    const cleanHash = hash.replace('#', '');

    if ($("#nav-" + cleanHash).length) {
      $('.paragraph--type--wrapper-tab-navigation .nav-link').removeClass('active');
      $('.paragraph--type--wrapper-tab-navigation .tab-pane').removeClass('active').removeClass('show');

      document.querySelector("#nav-tab-" + cleanHash).classList.add("active");
      document.querySelector("#nav-" + cleanHash).classList.add("active", "show");
    }

    // do nothing otherwise

  }


  Drupal.behaviors.tabNavUpdate = {
    attach: function (context, settings) {

      $('.js-tab-nav-update', context).once().on('click', function() {
        swapTab($(this).attr('href').split('#').pop());
      });
    }
  }


  swapTab(location.hash);

})(jQuery, Drupal);
